var _circle, _circle2, _circle3, _path, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsGroupWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 180,
    viewBox: "0 0 186 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5332,
    cy: 176.5,
    r: 3.5,
    fill: "#FF981F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0332,
    cy: 133,
    r: 5,
    fill: "#FF981F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 91,
    r: 70.5,
    fill: "#FF981F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.177 71.6798L117.835 100.589C118.201 101.452 118.362 102.154 118.408 102.883C118.499 104.586 117.904 106.241 116.735 107.515C115.566 108.785 113.985 109.534 112.267 109.625H78.7227C78.0124 109.582 77.3021 109.421 76.6376 109.171C73.3152 107.831 71.7113 104.062 73.0632 100.794L89.8354 71.6594C90.4082 70.6352 91.2789 69.7519 92.3558 69.1842C95.4719 67.4561 99.4358 68.5915 101.177 71.6798ZM97.4882 90.7319C97.4882 91.8219 96.5946 92.7325 95.4948 92.7325C94.395 92.7325 93.4785 91.8219 93.4785 90.7319V84.3078C93.4785 83.2155 94.395 82.3322 95.4948 82.3322C96.5946 82.3322 97.4882 83.2155 97.4882 84.3078V90.7319ZM95.4948 100.499C94.395 100.499 93.4785 99.588 93.4785 98.5003C93.4785 97.4081 94.395 96.4997 95.4948 96.4997C96.5946 96.4997 97.4882 97.3876 97.4882 98.4753C97.4882 99.588 96.5946 100.499 95.4948 100.499Z",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.533,
    cy: 160.5,
    r: 2.5,
    fill: "#FF981F"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 170.533,
    cy: 110.5,
    r: 2.5,
    fill: "#FF981F"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.0332,
    cy: 75,
    r: 1,
    fill: "#FF981F"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.466,
    cy: 27.5,
    r: 7.5,
    fill: "#FF981F"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.533,
    cy: 4.5,
    r: 2.5,
    fill: "#FF981F"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0332,
    cy: 10,
    r: 10,
    fill: "#FF981F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsGroupWarning);
export default __webpack_public_path__ + "static/media/dots-group-warning.0581e6771256d8dd1287754bb8727990.svg";
export { ForwardRef as ReactComponent };